export default [
  // Guest routes.
  ...middleware("guest", [
    { path: "/login", alias: '/', name: "login", component: require("@/pages/auth/login") },
    { path: "/home", name: "home", component: require("@/pages/auth/home") },
    { path: "/password/reset", name: "password.request", component: require("@/pages/auth/password/email") },
    { path: '/password/reset/:token', name: 'password.reset', component: require('@/pages/auth/password/reset') },
    { path: "/pass/request", name: "pass.request", component: require("@/pages/auth/pass/email") },
    { path: '/pass/reset', name: 'pass.reset', component: require('@/pages/auth/pass/reset') },
  ]),

  // Authenticated routes.
  ...middleware("auth", [
    { path: "/users", alias: '/', title: "Users", name: "users", component: require("@/pages/Users") },
    { path: "/pending/users", title: "Users to flag", name: "userspending", component: require("@/pages/UsersPending") },
    { path: "/posts", title: "Posts", name: "posts", component: require("@/pages/Posts") },
    { path: "/pending/posts", title: "Posts to flag", name: "postspending", component: require("@/pages/PostsPending") },
    { path: "/pets", title: "Pet of the week", name: "pets", component: require("@/pages/Pets") },
  ]),

  { path: "*", component: require("@/pages/errors/404.vue") },
];

/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware(middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  );

  return routes;
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js